import get from 'lodash/get';
import { generateUUID } from '../generateUUID';

export const getRequestCorrelation = (req = {}) => {
  const requestId =
    get(req, 'headers[x-hsbc-request-correlation-id]') || generateUUID();

  return {
    'x-hsbc-request-correlation-id': requestId,
  };
};
